import styled from "styled-components";
import Logo from "../common/assets/logo-white.png";
import FacebookIcon from "../common/assets/icon8-facebook.png";
import LogoWhiteMoto from "../common/assets/logo-pic-white-moto.png";

const FooterWrapper = styled.div`
    min-height: 100px;
    background-color: #053050;
    padding: 0 128px;
    margin-top: 64px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    @media screen and (max-width: 1000px){
        flex-direction: column;
        gap: 2vh;
        padding: 2vh 0;
    }
`

const Footer = () => {
    return (
        <FooterWrapper>
            <img src={Logo} alt="logo" />
            <img src={LogoWhiteMoto} alt="moto" />
            <a href="https://www.facebook.com/profile.php?id=61583635304088" target="_blank" rel="noopener noreferrer" >
                <img src={FacebookIcon} alt="facebook-icon" />
            </a>
        </FooterWrapper>
    )

}

export default Footer;